export default "__VITE_ASSET__BKEjvJJn__"